import { Radio } from '@shared/ui/Radio';

import cls from './RadioListItem.module.scss';

type RadioListItemProps = {
  onChange: (value: RadioListItemType) => void;
  label: string;
  value: RadioListItemType;
};

export type RadioListItemType = {
  min: number;
  max: number;
  active: boolean;
  id: string;
};

export const RadioListItem = ({ onChange, value, label }: RadioListItemProps) => {
  const onChangeHandler = () => {
    onChange(value);
  };

  return (
    <div className={cls.wrap}>
      <Radio
        onChange={onChangeHandler}
        label={label}
        className={cls.checkbox}
        value={value.active}
        testId={'filter-radio-item'}
      />
    </div>
  );
};
